<div class="py-4 holder">
    <span>{{toggleLabel}}</span>
    <label class="switch">
        <input (change)="checkChanged($event)" [(checked)]="isChecked" type="checkbox">
        <span class="slider round"></span>
    </label>
</div>